import { render, staticRenderFns } from "./UnsuccessPage.vue?vue&type=template&id=0f77b2f7"
import script from "./UnsuccessPage.vue?vue&type=script&lang=ts"
export * from "./UnsuccessPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports